<template>
  <div class="guarantee-pay">
    <!-- 平台代收 -->
    <template
      v-if="configInfo.collectGuaranteeMode === bondBidTypeDict.PLATFORM.value"
    >
      <div class="flex grey-line m-b-20">
        <span class="m-r-20">保证金：{{ guarantee.guaranteeFee | moneyFilter }}</span>
        <money-in-cn :money="guarantee.guaranteeFee" />
      </div>
      <el-descriptions size="medium">
        <el-descriptions-item label="缴款方式">
          <span v-if="payMethodDisabled">
            {{ guaranteePayMethodDict.translate(payMethod).label }}
          </span>
          <el-radio-group
            v-else
            v-model="payMethod"
            :disabled="payMethodDisabled"
          >
            <el-radio
              v-for="item in payMethodList"
              :key="item.value"
              :label="item.value"
            >
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-descriptions-item>
        <el-descriptions-item label="缴纳状态">
          <status-tag
            :type="gfPayStatusDictValue.type || 'primary'"
            :label="gfPayStatusDictValue.label || '未缴纳'"
            size="small"
          />
        </el-descriptions-item>
        <el-descriptions-item label="缴纳时间">
          <span>{{ tradeInfo.gfPayTime || ' - ' }}</span>
        </el-descriptions-item>
        <el-descriptions-item
          v-if="configInfo.depositEndTime"
          label="缴纳截止时间"
        >
          <span>{{ DateUtils.getNormMinute(configInfo.depositEndTime) }}</span>
        </el-descriptions-item>
        <el-descriptions-item v-if="showRefundInbox" label="保证金退回状态">
          <template slot="label">
            <span>保证金退回状态</span>
            <a-popover v-if="isBid" title="投标保证金退款说明">
              <bid-bond-refund-copywriter slot="content" />
              <a-icon type="question-circle" class="m-l-4 m-r-4" />
            </a-popover>
            <a-popover v-else title="投标保证金退款说明">
              <template slot="content">
                <p>1.中标结果公示后，非候选人单位可自行申请退款。</p>
                <p>
                  2.候选人单位，在中标结果公告后，若出现不能申请退款情况，请勿担心，该情况需要由招标方先同意退款才能申请退款。申请退款后，5日内有息退还。
                </p>
              </template>
              <a-icon type="question-circle" class="m-l-4 m-r-4" />
            </a-popover>
          </template>
          <span>
            {{
              transferInfo.isFreeze === depositFreezeStatusDict.FREEZE.value
                ? depositFreezeStatusDict.FREEZE.label
                : depositBackStatusDict.translate(transferInfo.gfBackStatus)
                  .tipLabel || '未退回'
            }}
          </span>
          <a-button
            v-if="showRefundBtn"
            type="link"
            class="m-l-4"
            style="padding: 0"
            @click="refund"
          >
            申请保证金退款
          </a-button>
          <a-button
            v-if="showRefundProcessBtn"
            type="link"
            class="m-l-4"
            style="padding: 0"
            @click="openRefundProgress"
          >
            查看退回进度
          </a-button>
        </el-descriptions-item>
      </el-descriptions>

      <div>
        <el-button
          v-if="
            payMethod === guaranteePayMethodDict.MONEY_TRANSFER.value &&
              !showTransfer
          "
          type="primary"
          @click="showMoneyTransfer"
        >
          生成保证金汇款账号
        </el-button>
      </div>

      <!-- 现金转账 -->
      <money-transfer
        v-if="showTransfer"
        :guarantee="guarantee"
        :info="transferInfo"
        @getAccount="getAccount"
        @getBalance="getBalance"
      />

      <!-- 线上保函 -->
      <!--<online-letter-->
      <!--  v-if="payMethod === guaranteePayMethodDict.ONLINE_LETTER.value"-->
      <!--  :order-id="orderId"-->
      <!--  :trade-id="tradeId"-->
      <!--  :order-status="orderStatus"-->
      <!--  :change-notice-id="changeNoticeId"-->
      <!--  :close-notice-id="closeNoticeId"-->
      <!--  :can-withdraw-time-node="canWithdrawTimeNode"-->
      <!--  @getLetter="getOnlineLetter"-->
      <!--/>-->

      <!-- 大地保函 -->
      <continent-letter
        v-if="payMethod === guaranteePayMethodDict.ONLINE_LETTER.value"
        :order-id="orderId"
        :trade-id="tradeId"
        :order-status="orderStatus"
        :change-notice-id="changeNoticeId"
        :close-notice-id="closeNoticeId"
        :can-withdraw-time-node="canWithdrawTimeNode"
        :business-no="tradeInfo.gfPayCode"
        :gf-letter-days="letterSetting.gfLetterDays"
        @reload="handleRefresh"
        @getStatus="getContinentLetterStatus"
      />

      <!-- 线下保函 -->
      <offline-letter
        v-if="payMethod === guaranteePayMethodDict.OFFLINE_LETTER.value"
        :order-id="orderId"
        :trade-id="tradeId"
        :order-status="orderStatus"
        :can-change-file-time-node="canWithdrawTimeNode"
        :gf-letter-days="letterSetting.gfLetterDays"
        @getLetter="getOfflineLetter"
        @refresh="handleRefresh"
      />
    </template>

    <!-- 自主收取或与第三方平台对接 -->
    <div v-else>
      <a-alert
        v-if="guarantee.gfPayStatus !== depositBidStatusDict.SUCCESS.value"
        banner
        class="banner-width"
      >
        <template slot="message">
          <span>
            提示：该保证金由招标单位自主收取，缴纳状态会有延迟。若已缴纳且长时间未更新缴纳状态，请联系招标单位。
          </span>
        </template>
      </a-alert>
      <a-descriptions class="m-t-10">
        <a-descriptions-item label="保证金">
          <div>
            <strong style="font-size: 20px;">
              {{ guarantee.guaranteeFee || '-' }} 元
            </strong>
            <span
              v-if="gfPayStatusDictValue.label"
              :class="`text-${gfPayStatusDictValue.type || 'danger'}`"
            >
              （ {{ gfPayStatusDictValue.label || '未缴纳' }} ）
            </span>
          </div>
          <money-in-cn :money="guarantee.guaranteeFee" class="m-t-4" />
        </a-descriptions-item>
      </a-descriptions>
    </div>

    <!---退回进度弹窗----->
    <a-modal
      title="保证金退回进度"
      :visible="visible"
      :width="700"
      :mask-closable="false"
      @cancel="visible = false"
    >
      <div v-if="isRefund" class="refund-inbox">
        <a-icon
          type="check-circle"
          theme="filled"
          class="refund-success-icon"
        />
        <p class="refund-result">保证金已退回</p>
        <p class="refund-tip">您的保证金已成功退回至缴纳账户，请注意查收</p>
      </div>
      <div v-else class="refund-inbox">
        <a-icon
          type="clock-circle"
          theme="filled"
          class="refund-warning-icon"
        />
        <p class="refund-result">保证金退回中</p>
        <p class="refund-tip">
          <span
            v-if="
              [
                depositBackStatusDict.PENDING.value,
                depositBackStatusDict.DELAY_RETURN.value
              ].includes(transferInfo.gfBackStatus)
            "
          >
            保证金预计5个自然日退回，请耐心等待...
          </span>
          <span v-else>正在处理退款，预计1个自然日退回</span>
        </p>
      </div>
      <div class="refund-step">
        <a-steps progress-dot :current="isRefund ? 1 : 0">
          <a-step
            title="保证金申请退回"
            :description="tradeInfo.gfBackApplyTime || '-'"
          />
          <a-step
            title="保证金已退回"
            :description="tradeInfo.gfBackTime || ''"
          />
        </a-steps>
      </div>
      <template slot="footer">
        <a-button size="large" type="primary" @click="visible = false">
          关闭
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
// 组件
import MoneyInCn from '@/components/common/MoneyInCn'
import StatusTag from '@/components/common/StatusTag'
import MoneyTransfer from '@/components/bid/guarantee/MoneyTransfer.vue'
// import OnlineLetter from '@/components/bid/guarantee/OnlineLetter'
import OfflineLetter from '@/components/bid/guarantee/OfflineLetter'
import ContinentLetter from '@/components/bid/guarantee/ContinentLetter.vue'
import BidBondRefundCopywriter from '@/components/copywriter/BidBondRefundCopywriter.vue'
// 工具
import { strToThousands } from '@/utils/utils'
// 字典
import { bondBidTypeDict, depositBidStatusDict } from '@/dictionary/project/bid'
import {
  depositBackStatusDict,
  depositFreezeStatusDict,
  guaranteeLetterOfflineStatusDict,
  guaranteeLetterOnlineStatusDict,
  guaranteePayMethodDict,
  guaranteePayMethodSupportDict,
  purchaseTypeDict
} from '@/dictionary/project/common'
import { cloneDeep } from 'lodash'
import {
  createGuaranteeAccountApi,
  refundBidBondApi,
  setGuaranteePayMethodApi
} from '@/api/supplier/bid'

import DateUtils from '@/utils/date'
import { onlineLetterApprovalStatusDict } from '@/dictionary/guarantee'

/**
 * @description 保证金支付
 */
export default {
  name: 'GuaranteePay',

  components: {
    MoneyInCn,
    StatusTag,
    MoneyTransfer,
    // OnlineLetter,
    OfflineLetter,
    ContinentLetter,
    BidBondRefundCopywriter
  },

  filters: {
    moneyFilter(val) {
      return strToThousands(val) + '元'
    }
  },

  props: {
    orderId: {
      type: [String, Number],
      default: ''
    },

    tradeId: {
      type: [String, Number],
      default: ''
    },

    // 保证金设置信息
    configInfo: {
      type: Object,
      default: () => {}
    },

    // 保证金交易信息
    tradeInfo: {
      type: Object,
      default: () => {}
    },

    // 变更公告id
    changeNoticeId: {
      type: [String, Number],
      default: ''
    },

    // 流标公告id
    closeNoticeId: {
      type: [String, Number],
      default: ''
    },

    // 允许申请撤回的时间节点
    canWithdrawTimeNode: {
      type: String,
      default: ''
    },

    // 项目状态
    orderStatus: {
      type: [String, Number],
      default: ''
    }
  },

  data() {
    return {
      // 数据字典
      depositFreezeStatusDict,
      guaranteePayMethodDict,
      depositBidStatusDict,
      depositBackStatusDict,
      bondBidTypeDict,

      // 日期工具类
      DateUtils,

      guarantee: {
        // 保证金金额
        guaranteeFee: '',
        // 保证金缴纳状态
        gfPayStatus: '',
        // 保证金缴纳时间
        gfPayTime: '',
        // 采购方式
        purchaseAlias: ''
      },

      // 当前选择的缴款方式
      payMethod: '',

      // 转账汇款信息
      transferInfo: {
        gfAccount: ''
      },

      // 保函信息
      letter: {},
      // 保函设置
      letterSetting: {
        // 保函有效期要求
        gfLetterDays: ''
      },

      visible: false,

      // 大地保函状态
      continentLetterStatus: ''
    }
  },

  computed: {
    // 是招标采购
    isBid() {
      return this.guarantee.purchaseAlias === purchaseTypeDict.BIDDING.alias
    },

    // 保证金缴纳状态字典翻译值
    gfPayStatusDictValue() {
      return depositBidStatusDict.translate(this.transferInfo.gfPayStatus) || {}
    },

    // 保证金缴纳时间
    guaranteePayTime() {
      // 根据缴款方式不同，取不同对象中的保证金缴纳时间
      if (this.payMethod === guaranteePayMethodDict.MONEY_TRANSFER.value) {
        return this.transferInfo.gfPayTime || ''
      }
      if (this.payMethod === guaranteePayMethodDict.ONLINE_LETTER.value) {
        return this.letter.gfLetterStartTime || ''
      }
      if (this.payMethod === guaranteePayMethodDict.OFFLINE_LETTER.value) {
        return this.letter.gfLetterApprovalTime || ''
      }
      return ''
    },

    // 缴款方式列表
    payMethodList() {
      const list = []
      // 支持现金
      if (
        this.configInfo.supportGf === guaranteePayMethodSupportDict.YES.value
      ) {
        list.push(guaranteePayMethodDict.MONEY_TRANSFER)
      }
      // 支持线上保函
      if (
        this.configInfo.supportOnlineGfLetter ===
        guaranteePayMethodSupportDict.YES.value
      ) {
        list.push(guaranteePayMethodDict.ONLINE_LETTER)
      }
      // 支持线下保函
      if (
        this.configInfo.supportOfflineGfLetter ===
        guaranteePayMethodSupportDict.YES.value
      ) {
        list.push(guaranteePayMethodDict.OFFLINE_LETTER)
      }
      return list.length > 0 ? list : [guaranteePayMethodDict.MONEY_TRANSFER]
    },

    // 展示汇款信息
    showTransfer() {
      // 有账户信息
      const hasAccount = Boolean(this.transferInfo.gfAccount)
      // 根据后台返回数据中的gfPayType，已指定使用现金转账
      const confirmUseMoney =
        this.configInfo.gfPayType ===
        guaranteePayMethodDict.MONEY_TRANSFER.value
      return hasAccount && confirmUseMoney
    },

    // 禁止切换缴纳方式
    payMethodDisabled() {
      // 当缴款方式仅有一种时，不允许切换
      if (this.payMethodList.length === 1) {
        return true
      }
      // 当选择银行转账且已生成汇款账户时，不允许切换
      if (this.payMethod === guaranteePayMethodDict.MONEY_TRANSFER.value) {
        return this.showTransfer
      }
      // 目前大地线上保函的保函状态在支付中心
      // 当大地保函状态不为开立失败时，不允许切换
      if (
        this.continentLetterStatus &&
        this.continentLetterStatus !==
          onlineLetterApprovalStatusDict.FAILED.value
      ) {
        return true
      }

      // 当选择线上保函时，保函状态仅审核中和已开立时不允许切换，退款状态为退款中时不允许切换
      // if (this.payMethod === guaranteePayMethodDict.ONLINE_LETTER.value) {
      //   // 如果退款状态和理赔状态有值，则允许切换
      //   if (
      //     this.letter.refundStatus ===
      //     guaranteeLetterOnlineRefundStatusDict.REFUNDING.value
      //   ) {
      //     return true
      //   }
      //   const { AUDITING, OPENED } = guaranteeLetterOnlineStatusDict
      //   if (
      //     this.letter.gfLetterStatus === AUDITING.value ||
      //     this.letter.gfLetterStatus === OPENED.value
      //   ) {
      //     return true
      //   }
      //   return false
      // }
      // 当选择线下保函时，提交审核后，仅保函审核不通过时允许切换
      if (this.payMethod === guaranteePayMethodDict.OFFLINE_LETTER.value) {
        return (
          this.letter.approvalStatus !==
            guaranteeLetterOfflineStatusDict.AUDIT_FAIL.value &&
          !!this.letter.gfLetterFileId
        )
      }
      return false
    },

    // 是否展示退款这项
    showRefundInbox() {
      /**
       * 仅当选择的付款方式为银行转账、已缴金额>0且平台收取时展示
       * || 退回成功
       */
      // 缴款方式为银行转账
      return (
        (Number(this.transferInfo.accountBalance) > 0 &&
          this.configInfo.collectGuaranteeMode ===
            bondBidTypeDict.PLATFORM.value) ||
        this.transferInfo.gfBackStatus == depositBackStatusDict.RETURNED.value
      )
    },

    // 显示退款按钮
    showRefundBtn() {
      const arr = [
        depositBackStatusDict.PENDING.value,
        depositBackStatusDict.NOT_FULLY_PAID.value
      ]
      return arr.includes(this.transferInfo.gfBackStatus)
    },

    // 显示退回进度按钮
    showRefundProcessBtn() {
      const arr = [
        depositBackStatusDict.APPLIED.value,
        depositBackStatusDict.RETURNED.value,
        depositBackStatusDict.DELAY_RETURN.value,
        depositBackStatusDict.QUEUE_REFUND1.value,
        depositBackStatusDict.QUEUE_REFUND2.value
      ]
      return arr.includes(this.transferInfo.gfBackStatus)
    },

    // 已退回
    isRefund() {
      return (
        this.transferInfo.gfBackStatus === depositBackStatusDict.RETURNED.value
      )
    }
  },

  watch: {
    configInfo: {
      handler(val) {
        this.transferInfo = Object.assign({}, this.transferInfo, val)
        this.letterSetting.gfLetterDays = val.gfLetterDays
        // 如果投标单位已选择缴款方式，则使用指定的缴款方式
        if (val.gfPayType) {
          this.payMethod = val.gfPayType
        }
      },
      deep: true,
      immediate: true
    },

    tradeInfo: {
      handler(val) {
        this.guarantee = {
          // 保证金金额
          guaranteeFee: val?.guaranteeFee,
          // 保证金缴纳状态
          gfPayStatus: '',
          // 保证金缴纳时间
          gfPayTime: '',
          // 采购方式
          purchaseAlias: val?.purchaseAlias
        }
        this.transferInfo = Object.assign({}, this.transferInfo, val)
      },
      deep: true,
      immediate: true
    }
  },

  created() {
    // 如果投标单位没有选择保证金缴款方式，则默认选择第一个缴款方式
    if (!this.configInfo.gfPayType) {
      this.payMethod = this.payMethodList[0].value
    }
  },

  methods: {
    /**
     * 展示现金转账的支付方式内容
     */
    async showMoneyTransfer() {
      try {
        // 如果有其它缴款方式，则需要提示，否则不需要
        const someOtherMethod =
          this.configInfo.supportOnlineGfLetter ===
            guaranteePayMethodSupportDict.YES.value ||
          this.configInfo.supportOfflineGfLetter ===
            guaranteePayMethodSupportDict.YES.value
        if (someOtherMethod) {
          // 如果线上保函申请状态为申请中，则需要提示用户
          if (
            this.letter.gfLetterStatus ===
            guaranteeLetterOnlineStatusDict.APPLYING.value
          ) {
            const bool = await this.$systemConfirm(
              '您当前正在申请电子保函，如继续需生成汇款账户，请勿在第三方平台继续操作',
              '生成汇款账户确认'
            )
            if (!bool) return
          } else {
            const bool = await this.$systemConfirm(
              '生成汇款账户后，将不再支持使用投标保函方式缴纳保证金，请确认',
              '确认提示'
            )
            if (!bool) return
          }
        }

        await createGuaranteeAccountApi(this.orderId, this.tradeId)
        this.getAccount()
      } catch (err) {
        console.error('设置保证金缴费方式失败', err)
        if (err?.message) this.$message.error(err.message)
      }
    },

    /**
     * 获取汇款账户信息
     */
    getAccount() {
      this.$emit('getAccount')
    },

    /**
     * 获取汇款余额
     */
    getBalance() {
      this.$emit('getBalance')
    },

    /**
     * 获取线上保函信息
     */
    getOnlineLetter(letter) {
      this.letter = cloneDeep(letter)
    },

    /**
     * 获取线下保函信息
     */
    getOfflineLetter(letter) {
      this.letter = cloneDeep(letter)
    },

    /**
     * 发起保证金退款
     */
    async refund() {
      if (this.transferInfo.isFreeze === depositFreezeStatusDict.FREEZE.value) {
        await this.$alert(
          '该笔保证金已被冻结，请联系项目负责人协商处理，解冻后可申请退回',
          '系统提示',
          { confirmButtonText: '知道了' }
        )
        return
      }

      await this.$confirm('是否申请退款', '提示', { type: 'warning' })

      try {
        await refundBidBondApi({
          orderId: this.orderId,
          tradeId: this.tradeId
        })
        this.$message.success('申请保证金退款成功')
        this.$emit('refresh')
      } catch (error) {
        this.$message.error(error.message)
      }
    },

    /**
     * 打开退回进度弹窗
     */
    openRefundProgress() {
      this.visible = true
    },

    /**
     * 刷新页面
     */
    handleRefresh() {
      this.$emit('refresh')
    },

    /**
     * 获取大地线上保函状态
     */
    getContinentLetterStatus(status) {
      this.continentLetterStatus = status
    }
  }
}
</script>

<style lang="scss" scoped>
.guarantee-pay {
  ::v-deep .el-descriptions {
    .el-descriptions-item {
      vertical-align: top !important;
      padding-bottom: 16px !important;
    }
  }
}

::v-deep {
  .ant-descriptions-row,
  .ant-descriptions-item-content {
    vertical-align: top;
  }

  .ant-descriptions-row > th,
  .ant-descriptions-row > td {
    padding-bottom: 12px;
  }

  .ant-btn {
    height: auto;
  }
  .ant-alert-message {
    color: $second-text-color;
  }
}

.refund-inbox {
  text-align: center;
  .refund-warning-icon {
    font-size: 56px;
    color: $warning-color;
  }
  .refund-success-icon {
    font-size: 56px;
    color: $success-color;
  }
  .refund-result {
    font-size: 20px;
    padding: 16px 0 8px;
    font-weight: bold;
    color: $text-color;
    margin-block-start: 0em;
    margin-block-end: 0em;
  }
  .refund-tip {
    font-size: 14px;
    color: $second-text-color;
  }
}

.refund-step {
  width: 540px;
  padding: 24px 100px;
  border: 1px solid $info-fourth-color;
  margin: 0 auto;
  border-radius: 4px;
}

::v-deep .anticon-question-circle {
  color: $primary-color;
  font-size: 16px;
}

.grey-line {
  padding: 12px 14px;
  background: #F1F4FA;
  border-radius: 4px;
  color: $text-color;
  line-height: 16px;
  font-size: 16px;

  ::v-deep .money-in-cn{
    font-size: 14px;
    line-height: 16px;
  }
}
</style>
